// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__eat97","wrappererror":"styles_wrappererror__elGNx","wrappersuccess":"styles_wrappersuccess__OHt64"};